<template>
    <div>
        <v-container fluid id="home" class="fill-height">
            <v-snackbar v-model="snackbar" :timeout="10000" top color="red">
                <span>{{message}}</span>
                <v-btn text color="white" @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-row justify-center align="center" justify="center">
                <v-col cols="12" md="12" sm="4" class="mt-12">
                    <v-card class="pa-12 mx-auto mt-12" id="login" max-width="500px" elevation="7">
                        <h3 class="text-center" style="color:#1a00d4">SET NEW PASSWORD</h3>
                        <v-card-text class="mt-2">
                            <v-form ref="form">
                                <v-text-field outlined dense class="mt-7" label="Password" name="password" v-model="password"
                                    :append-icon="show1 ? 'visibility' : 'visibility_off'" color="#1a00d4"
                                    :type="show1 ? 'text' : 'password'"
                                    @click:append="show1 = !show1"
                                    prepend-inner-icon="mdi-lock"
                                    :rules="passwordRules"
                                    >
                                </v-text-field>
                                <v-text-field outlined dense class="" label="Confirm Password" name="confirmpassword" v-model="confirmPassword"
                                    :append-icon="show2 ? 'visibility' : 'visibility_off'" color="#1a00d4"
                                    :type="show2 ? 'text' : 'password'"
                                    @click:append="show2 = !show2"
                                    prepend-inner-icon="mdi-lock"
                                    :rules="passwordRules2"
                                    >
                                </v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-text class="text-center mt-5">
                            <v-btn style="color:#1a00d4" class="" :loading="loading" v-on:click="reset()">
                                Submit
                            </v-btn>
                        </v-card-text>

                    </v-card>
                </v-col>
               
                
            </v-row>
        </v-container>  
    </div>
</template>
<script>
export default {
    data(){
        return{
            message:'',
            snackbar:'',
            loading:false,
            show1: false,
            show2: false,
            password:'',
            confirmPassword:'',
            passwordRules: [v => !!v || 'Password is required',
                v => v.length > 5 || 'Password must not be less than 6 characters'

            ],
            passwordRules2: [v => !!v || 'Confirm Password is required',
                v => v.length > 5 || 'Confirm Password must not be less than 6 characters'

            ]
        }
        
    },
    methods:{
        reset(){
            if (this.$refs.form.validate()){
                if(this.password===this.confirmPassword){
                    this.loading=true
                    this.$store.dispatch("SetNewPassword",{
                    "username":this.$route.query.username,
                    "code":this.$route.query.code,
                    "email":this.$route.query.email,
                    "password":this.password,
                    })
                    .then((success)=>{
                        console.log(success)
                        this.loading = false
                        this.$router.push('/login')
                    })
                    .catch((error)=>{
                        if(error.response.status===400){
                            this.loading= false
                            this.message= 'This link seems broken. Please refer back to your mail'
                            this.snackbar = true
                        }else{
                            this.loading = false
                            console.log(error.response)
                            this.message = error.response.data.message
                            this.snackbar= true
                        }       
                    })
                }else{
                    this.message = 'Password and Confirm Password must match'
                    this.confirmPassword= ''
                    this.snackbar= true
                }
                
            }
        }
    },
    created(){
        
    }
}
</script>
<style scoped>
    #login{
        border-radius: 5px;
    }
</style>